export const HOST_GET_PROTECTION_PROOF = "HOST_GET_PROTECTION_PROOF"
export const HOST_GET_PROTECTION_PROOF_SUCCESSFUL = "HOST_GET_PROTECTION_PROOF_SUCCESSFUL"
export const HOST_GET_PROTECTION_PROOF_FAILED = "HOST_GET_PROTECTION_PROOF_FAILED"
export const HOST_GET_PROTECTION_PROOF_RESET = "HOST_GET_PROTECTION_PROOF_RESET"

